export default "__VITE_ASSET__DD_Y$TFR__"